module.exports = __webpack_public_path__ + "img/webphone.dabbf4d1.png";